import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { setDateFormat } from "@/lib/helpers";

const SchoolContext = createContext({ school: {}, refreshSchool: () => {} });
export const useSchool = () => useContext(SchoolContext);

export function SchoolProvider({ children }) {
  const { user } = useAuth();
  const [school, setSchool] = useState({});

  const refreshSchool = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSchool(data || {});
      if (data?.date_format) setDateFormat(data.date_format);
    } catch { /* ignore */ }
  }, []);

  useEffect(() => { if (user) refreshSchool(); }, [user, refreshSchool]);

  useEffect(() => {
    const h = () => refreshSchool();
    window.addEventListener("drill-change", h);
    return () => window.removeEventListener("drill-change", h);
  }, [refreshSchool]);

  useEffect(() => {
    const name = school?.school_name || "SSSPS";
    const tag = school?.tag_line ? ` · ${school.tag_line}` : "";
    document.title = `${name}${tag}`;
    if (school?.logo) {
      let link = document.querySelector("link[rel='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = school.logo;
    }
  }, [school]);

  return (
    <SchoolContext.Provider value={{ school, refreshSchool }}>
      {children}
    </SchoolContext.Provider>
  );
}
